import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage
import { combineReducers } from '@reduxjs/toolkit'
import authSlice from '../features/auth/authSlice'
import { authApi } from './services/auth/authService'
import userSlice from '../features/auth/userSlice'
import alertSlice from '../features/auth/alertSlice'
import userDetailsSlice from '../features/userDetailsSlice'
import cartSlice from '../features/cartSlice'
import filterSection from '../features/filterSectionSlice'
import chatSlice from '../features/chatRedux/chatSlice'
import adminSlice from '../features/admin/adminSlice'

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user'], // Only persist these reducers
  blacklist: ['notifications', 'details', 'cartDetails'] // Don't persist temporary data
}

// Combine reducers
const rootReducer = combineReducers({
  auth: authSlice,
  [authApi.reducerPath]: authApi.reducer,
  user: userSlice,
  notifications: alertSlice,
  details: userDetailsSlice,
  cartDetails: cartSlice,
  userDesignation: filterSection,
  chat: chatSlice,
  admin: adminSlice
})

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(authApi.middleware),
})

export const persistor = persistStore(store)
export default store
